import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationFlowRate
} from 'services/equipmentSets/types';
import { makeSelectCalibrationFlowRate } from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    flowRate: CalibrationFlowRate;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsFlowRateListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { flowRate } = this.props;

        return <ListItem description="Flow rate" value={`${flowRate} l/min`} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    flowRate: makeSelectCalibrationFlowRate()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsFlowRateListItemComponent
);
